/**
 * @file SkuSelectedCard.tsx
 * @description Карточка выбранной фасовки в панели складского документа
 * (phase19.24 этап 1, шаг 1).
 *
 * Один вид на приёмку, списание и перемещение: название сверху, артикул (в
 * перемещении — с остатком) моноширинным снизу, справа сброс с тач-целью
 * 48px. До выделения каждое поле рисовало карточку само, и отличались они
 * молча — при правке одного места второе оставалось прежним.
 */

import { X } from "lucide-react";

import { Button } from "../ui/button";

interface Props {
  /** «Иван-чай гранулированный — 50 г». */
  title: string;
  /** Вторая строка: артикул, при необходимости с остатком склада. */
  subtitle: string;
  disabled?: boolean;
  /** Сброс выбора — панель возвращается к полю скана. */
  onReset: () => void;
}

export function SkuSelectedCard({ title, subtitle, disabled = false, onReset }: Props) {
  return (
    <div className="flex min-h-[56px] items-center gap-2 rounded-xl bg-primary/5 px-3 py-2 ring-1 ring-primary/40">
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-medium">{title}</span>
        <span className="truncate font-mono text-xs text-on-surface-variant">
          {subtitle}
        </span>
      </div>
      <Button
        type="button"
        variant="ghost"
        onClick={onReset}
        disabled={disabled}
        className="size-12 shrink-0 p-0"
        aria-label="Сбросить выбор фасовки"
        title="Сбросить"
      >
        <X className="size-5" />
      </Button>
    </div>
  );
}
